import * as z from 'zod'

export const addRateSchema = z.object({
  rate: z.number(),
  comment: z.string().optional(),
})

export type AddRateDto = z.infer<typeof addRateSchema>
